
	import { Component, Vue, Watch } from 'vue-property-decorator';
	import {AxiosStatic} from "axios";
	import MultidayCalendar from "@/components/reservation/MultidayCalendar.vue";
	import SingledayCalendar from "@/components/reservation/SingledayCalendar.vue";
	import IResource from "@/IResource";
	import IOrganisationAvailability from "@/IOrganisationAvailability";
	import IAvailability from "@/IAvailability";
	import ResourceimageGallery from '@/components/reservation/ResourceimageGallery.vue';
	import DayOverview from '@/components/reservation/DayOverview.vue';
	import { mixins } from 'vue-class-component';
	import { Device } from '@/mixins/Device';
	import FloatingBottomBar from '@/components/reservation/FloatingBottomBar.vue';

	@Component({
		components: {
			FloatingBottomBar,
			DayOverview,
			MultidayCalendar,
			SingledayCalendar,
			ResourceimageGallery
		},
	})
	export default class StepCalendar extends mixins(Device) {

		public $http!: AxiosStatic;

		$refs!: {
			calendarContainer: HTMLDivElement
		}

		public selectedDate: Date | null = null;

		get resource(): IResource {
			return this.$store.state.resource;
		}

		get availability(): IAvailability {
			return this.$store.state.availability;
		}

		get resourcehash() {
			return this.$store.state.resourcehash;
		}

		get showMobileDetails(): boolean {
			return this.isMobile && this.resource && this.resource.reservation_show_details > 0 && this.resource.type === 'singleday';
		}

		get logoUrl(): string {
			if (this.resource.logo) {
				return '/' + this.resource.logo;
			} else {
				return '';
			}
		}

		get indexedAvailability(): IOrganisationAvailability {
			let av = {};
			if (this.resource && this.availability) {
				this.$set(av, this.resource.id, this.availability);
			}
			return av;
		}

		public mounted() {
			this.loadAvailability();
		}

		@Watch('resourcehash')
		public async loadAvailability(): Promise<void> {
			if (this.$store.state.resourcehash) {
				let rangeStart = new Date();
				rangeStart.setMonth(rangeStart.getMonth() - 1, 15);
				let rangeEnd = new Date();
				rangeEnd.setMonth(rangeEnd.getMonth() + 6, 31);

				// load availability for the next 6 months (enough for single and multiday calendars)
				let url = '/public/resource/' + this.$store.state.resourcehash + '/availability?start=' + rangeStart.toISOString().substring(0,10) + '&end=' + rangeEnd.toISOString().substring(0,10);
				let response = await this.$http.get(url);
				this.$store.commit('SET_AVAILABILITY', response.data)

				// load availability for the next 15 years
				rangeEnd.setFullYear(rangeEnd.getFullYear() + 15);
				url = '/public/resource/' + this.$store.state.resourcehash + '/availability?start=' + rangeStart.toISOString().substring(0,10) + '&end=' + rangeEnd.toISOString().substring(0,10);
				response = await this.$http.get(url);
				this.$store.commit('SET_AVAILABILITY', response.data)
			}
		}

		public onSelectDate(date: Date) {
			if (this.showMobileDetails) {
				if (!this.selectedDate) {
					this.$nextTick(() => {
						this.$refs['calendarContainer']?.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'})
					})
				}
				this.selectedDate = new Date(date);
			} else {
				this.$store.commit('SET_STARTDATE', date);
				this.$store.commit('SET_ENDDATE', date);
				this.$store.commit('SET_STEP', 'step2')
			}
		}

		public continueWithDate() {
			if (this.selectedDate) {
				this.$store.commit('SET_STARTDATE', this.selectedDate);
				this.$store.commit('SET_ENDDATE', this.selectedDate);
				this.$store.commit('SET_STEP', 'step2')
			}
		}
	}
